import React, {createContext, useEffect, useReducer} from "react";
import {useIntl} from "react-intl";
import PropTypes from "prop-types";
import LocaleReducer from "../reducers/localeReducer";
import {useSupportedLanguages} from "../../hooks/useSupportedLanguages";
import {useLocation, reloadWithLocale} from "../../common/common";
import {getEntries} from "../../selectors/languageSelect";
import {LANGUAGE} from "../../common/i18n/locales/localeConstant";

const initialState = {
    locale: "en-gb",
    localeUppercase: "en-GB",
    localeUppercaseUnderscore: "en_GB",
    localeSelection: {
        localeOptions: [],
        localeSelected: "en-gb"
    }
};

const transformLocaleSecondWordToUppercase = (locale) => {
    const splitted = locale.split("-");
    return splitted[0] + "-" + splitted[1].toUpperCase();
};

const transformLocaleSecondWordToUppercaseUnderscore = (locale) => {
    const splitted = locale.split("-");
    return splitted[0] + "_" + splitted[1].toUpperCase();
};

const LocaleProvider = ({children}) => {
    const {locale} = useIntl();
    const {location} = useLocation();
    const {supportedLanguages} = useSupportedLanguages(transformLocaleSecondWordToUppercase(locale));
    const [localeState, localeDispatch] = useReducer(LocaleReducer, initialState);

    initialState.locale = locale;
    initialState.localeUppercase = transformLocaleSecondWordToUppercase(locale);
    initialState.localeUppercaseUnderscore = transformLocaleSecondWordToUppercaseUnderscore(locale);

    // Fetching supported languages and providing selection dictionary
    useEffect(() => {
        if (supportedLanguages && supportedLanguages.length) {
            initialState.localeSelection.localeOptions = (getEntries(supportedLanguages));
            localeDispatch({type: "ROUTE_CHANGED", payload: {}});
        }
    }, [supportedLanguages, location]);

    // Checking if locale is in url, adding it and reloads
    useEffect(() => {
        if (locale === LANGUAGE.DE_AT) {
            initialState.localeSelection.localeSelected = ("at_DE");
        } else if (locale === LANGUAGE.DE_CH) {
            initialState.localeSelection.localeSelected = ("ch_DE");
        } else {
            initialState.localeSelection.localeSelected = (initialState.localeUppercaseUnderscore);
        }
        reloadWithLocale(locale);
    }, []);

    return (
        <LocaleContext.Provider value={[localeState, localeDispatch]}>
            {children}
        </LocaleContext.Provider>
    );
};

LocaleProvider.propTypes = {
    children: PropTypes.any
};

export const LocaleContext = createContext(initialState);
export default LocaleProvider;
